import React, { useMemo } from 'react';

const COLORS = [
  'bg-blue-100 text-blue-700',
  'bg-green-100 text-green-700',
  'bg-yellow-100 text-yellow-700',
  'bg-red-100 text-red-700',
  'bg-purple-100 text-purple-700',
  'bg-pink-100 text-pink-700',
  'bg-indigo-100 text-indigo-700',
  'bg-teal-100 text-teal-700',
];

const getInitials = (name) => {
  if (!name) return '?';
  const parts = name.trim().split(' ').filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0][0].toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

const getColorIndex = (name) => {
  if (!name) return 0;
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  return Math.abs(hash) % COLORS.length;
};

export const Avatar = ({ name, src, size = 'md', className = '', active = false }) => {
  const sizeClasses = {
    xs: 'w-6 h-6 text-[10px]',
    sm: 'w-8 h-8 text-xs',
    md: 'w-10 h-10 text-sm',
    lg: 'w-12 h-12 text-base',
    xl: 'w-14 h-14 text-lg'
  };

  const activeSizes = {
    xs: 'w-2 h-2',
    sm: 'w-2.5 h-2.5',
    md: 'w-3 h-3',
    lg: 'w-3.5 h-3.5',
    xl: 'w-4 h-4'
  };

  const colorClass = useMemo(() => COLORS[getColorIndex(name)], [name]);
  const initials = useMemo(() => getInitials(name), [name]);

  return (
    <div className={`relative inline-block ${className}`}>
      {src ? (
        <img 
          src={src} 
          alt={name} 
          className={`${sizeClasses[size]} rounded-full object-cover border border-gray-100 shadow-sm`}
        />
      ) : (
        <div className={`${sizeClasses[size]} rounded-full flex items-center justify-center font-semibold ${colorClass} shadow-sm border border-white/50`}>
          {initials}
        </div>
      )}
      {active && (
        <span className={`absolute bottom-0 right-0 block rounded-full ring-2 ring-white bg-green-500 ${activeSizes[size]}`} />
      )}
    </div>
  );
};
